import api from "./index"

export async function getPatientReports({
  patientId,
  offset = 0,
  limit = 10,
} = {}) {
  return api.get(`/v1/patients/${patientId}/reports`, {
    params: { offset, limit },
  })
}

export async function createPatientReport(patientId, formData) {
  return api.post(`/v1/patients/${patientId}/reports`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

export async function getSignedUrl(filePath) {
  // API expects an array of paths
  const paths = Array.isArray(filePath) ? filePath : [filePath]
  return api.post("/v1/files/signedUrl", paths)
}

export async function saveMessageAsReport(patientId, data) {
  return api.post(`/v1/patients/${patientId}/reports:saveMessage`, data)
}
